import { SeoHeadingHandler } from '@/seo/heading/SeoHeadingHandler';

export class Default extends SeoHeadingHandler {
	public canHandle(): Promise<boolean> {
		return Promise.resolve(true);
	}

	protected async selfHandle(): Promise<string> {
		return Promise.resolve('Browse all universities from around the world');
	}
}
